import axios from '@/utils/request'
import base from './base'
import qs from 'qs'

// 广告列表（分页，form-encoded）
export function adConfigList(data) {
  return axios.post(`${base.url}/business/adConfig/list`, qs.stringify(data))
}

// 审核状态统计
export function adConfigStats() {
  return axios.post(`${base.url}/business/adConfig/stats`)
}

// 广告详情（含素材列表）
export function adConfigDetail(id) {
  return axios.post(`${base.url}/business/adConfig/detail`, qs.stringify({ id }))
}

// 新增/编辑广告（JSON）
export function adConfigSave(data) {
  return axios.post(`${base.url}/business/adConfig/save`, JSON.stringify(data), {
    headers: { 'Content-Type': 'application/json' }
  })
}

// 删除广告（JSON 数组）
export function adConfigDelete(ids) {
  return axios.post(`${base.url}/business/adConfig/delete`, JSON.stringify(ids), {
    headers: { 'Content-Type': 'application/json' }
  })
}

// 审核单个广告（JSON）
export function adConfigReview(data) {
  return axios.post(`${base.url}/business/adConfig/review`, JSON.stringify(data), {
    headers: { 'Content-Type': 'application/json' }
  })
}

// 批量审核广告（JSON）
export function adConfigBatchReview(data) {
  return axios.post(`${base.url}/business/adConfig/batchReview`, JSON.stringify(data), {
    headers: { 'Content-Type': 'application/json' }
  })
}

// 下线广告（JSON 数组）
export function adConfigOffline(ids) {
  return axios.post(`${base.url}/business/adConfig/offline`, JSON.stringify(ids), {
    headers: { 'Content-Type': 'application/json' }
  })
}

// 复制广告
export function adConfigCopy(id) {
  return axios.post(`${base.url}/business/adConfig/copy`, qs.stringify({ id }))
}

// 调整排序
export function adConfigSort(id, sort) {
  return axios.post(`${base.url}/business/adConfig/sort`, qs.stringify({ id, sort }))
}

// 上传广告素材（multipart，走 cloud 七牛上传接口）
export function adConfigUpload(file) {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('dir', 'ad')
  return axios.post(`${base.url}/cloud/qiniuUpload/upload`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}
